module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_9006.21914433.png";